import { registerFonts } from './register-fonts-shared';

// Import font files from local assets
import MaisonNeueBook from './fonts/MaisonNeue-Book.ttf';
import MaisonNeueMedium from './fonts/MaisonNeue-Medium.ttf';
import MaisonNeueBookItalic from './fonts/MaisonNeue-BookItalic.ttf';
import MaisonNeueBold from './fonts/MaisonNeue-Bold.ttf';

// Register fonts for browser environment
registerFonts({
  MaisonNeueBook,
  MaisonNeueMedium,
  MaisonNeueBookItalic,
  MaisonNeueBold,
});
